import React from "react";
import { classNames } from "primereact/utils";
import MultiCustomerCheck from "../MultiCustomerCheck";
import ReferenceModel from "../../Models/ReferenceModel";
import TruncatedText from "./TruncatedText/TruncatedText";
import "./WorkflowCustomerTag.scss";

export interface WorkflowCustomerTagProps {
    customer?: ReferenceModel | null;
    customerName?: string | null;
    isMultiCustomer?: boolean;
    className?: string;
    truncate?: boolean;
}

const WorkflowCustomerTag: React.FC<WorkflowCustomerTagProps> = ({
    customer,
    customerName,
    isMultiCustomer,
    className,
    truncate = false,
}) => {
    const multiCustomer = isMultiCustomer ?? (MultiCustomerCheck() as boolean);
    const label = `${customerName ?? customer?.name ?? ""}`.trim();

    if (!multiCustomer || !label) {
        return null;
    }

    return (
        <span className={classNames("workflow-customer-tag", className)}>
            {truncate ? (
                <TruncatedText text={label} className="workflow-customer-tag__text" />
            ) : (
                label
            )}
        </span>
    );
};

export default WorkflowCustomerTag;
